export interface ScreenMetrics {
  /** Cell width in CSS px (even). */
  cw: number;
  /** Cell height in CSS px. */
  ch: number;
}

/**
 * Size a `.screen` element so every cell and every sixel block is a whole
 * number of CSS pixels (fractional cells leave anti-aliased seams). Cells
 * keep the 5:6 teletext aspect; the text stretch factor follows from that.
 */
export function sizeScreen(screenEl: HTMLElement, cw: number): ScreenMetrics {
  cw -= cw % 2; // even so the two sixel columns are whole pixels
  cw = Math.max(cw, 4);
  const ch = Math.round(cw * 1.2);
  const s1 = Math.round(ch * 0.3);
  const s2 = ch - 2 * s1;
  const st = screenEl.style;
  st.setProperty('--cw', `${cw}px`);
  st.setProperty('--ch', `${ch}px`);
  st.setProperty('--s1', `${s1}px`);
  st.setProperty('--s2', `${s2}px`);
  st.setProperty('--s3', `${s1}px`);
  st.setProperty('--sx', (cw / (0.6 * ch)).toFixed(4));
  return { cw, ch };
}

/** Largest cell size that fits the given box. */
export function fitScreen(screenEl: HTMLElement, availWidth: number, availHeight: number): ScreenMetrics {
  const byWidth = Math.floor(availWidth / 40);
  const byHeight = Math.floor(availHeight / (25 * 1.2));
  return sizeScreen(screenEl, Math.min(byWidth, byHeight));
}
